import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

const TutorialPreviewItem = ({ tutorial, className }) => (
  <article className={className} css={{ position: `relative` }}>
    <Link to={tutorial.link}>
      <h2>{tutorial.title}</h2>
      <p css={{ fontWeight: `normal` }}>{tutorial.description}</p>
    </Link>
  </article>
);

TutorialPreviewItem.propTypes = {
  tutorial: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default TutorialPreviewItem;
